import styled from "styled-components";
import Button from '@material-ui/core/Button';

export const FileButton = styled(Button)`
  background: var(--azul) !important;
  color : #fff !important;
  border-radius: 20px !important;
  margin: 5px !important;
  font-size: 10px !important;
`